module.exports = __webpack_public_path__ + "img/good-boi.jpg_w545.7c5d4470.jpg";